import { render, staticRenderFns } from "./calendarDay.vue?vue&type=template&id=2a70e389&"
import script from "./calendarDay.vue?vue&type=script&lang=js&"
export * from "./calendarDay.vue?vue&type=script&lang=js&"
import style0 from "./calendarDay.vue?vue&type=style&index=0&id=2a70e389&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports